import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { CreditCardModel } from '../models/models'

export class GetDealerCreditCardsApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/dealer/getDealerCreditCards',
      requesterInfo,
    })
  }

  public async getDealerCreditCards(req: any): Promise<CreditCardModel[]> {
    return await this.postAsync<CreditCardModel[]>(req)
  }
}
